export enum LocumsMarginExpenseAs {
    REIMBURSEMENT = 'Reimbursement',
    INTERNAL_COST = 'Internal Cost',
    BOOKED_BY_AYA = 'Booked by Aya'
}
